import React from 'react';
import SchedulerCalendar from '../../../components/calendar/SchedulerCalendar';
const ECOPETROL_ID = 'f17f5547-a8eb-45c9-b4a5-309c1ca7cf05';

export default function ViewEcopetrol() {
  return (
    <div className="operation-view ecopetrol-view">
      <SchedulerCalendar operationId={ECOPETROL_ID} />
    </div>
  );
}